import React from 'react';
import SocialBoxItem from './SocialBoxItem';
import styles from './styles.module.scss';

function SocialContactItems(props) {
	return (
		<div className={styles.socialDiv}>
			<SocialBoxItem
				link='https://www.linkedin.com/in/sarah23s/'
				icon='linkedin'
				className={props.className}
			/>
			<SocialBoxItem
				link='https://github.com/sarah23s'
				icon='github-square'
				className={props.className}
			/>
			<SocialBoxItem
				link='https://gitlab.com/sarah23s'
				icon='gitlab'
				className={props.className}
			/>
			{/* <SocialBoxItem
				link='https://www.instagram.com/sarah_23s/'
				icon='instagram'
				className={props.className}
			/> */}
			<SocialBoxItem
				link='https://www.facebook.com/sarah23s'
				icon='facebook-square'
				className={props.className}
			/>
			<SocialBoxItem
				link='https://twitter.com/23s_sarah'
				icon='twitter-square'
				className={props.className}
			/>
		</div>
	);
}

export default SocialContactItems;
